import React, { useEffect, useState } from "react";

import { handleEditorChange, prepareEditorContentImage } from "utils";

import { Popup } from "models";

import { Col, Form, Input, Row, TextEditor } from "components";

export const PopupInputs = ({ popup }: { popup: Popup }) => {
  const [content, setContent] = useState<string>(popup.content);
  const [showButton, setShowButton] = useState<boolean>(popup.button || false);
  const form = Form.useFormInstance();

  const button = Form.useWatch("button", form);

  useEffect(() => {
    form.setFieldValue(`${popup.language}-content`, content);
  }, [content, form, popup]);

  useEffect(() => {
    setShowButton(!button);
  }, [button]);

  return (
    <>
      <Row>
        <Col>
          <Input name={`${popup.language}-headline`} label="Headline" rules={[{ required: true }]} initialValue={popup ? popup.headline : ""} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            name={`${popup.language}-buttonText`}
            label="Button text"
            rules={[{ required: false }]}
            initialValue={popup ? popup.buttonText : ""}
            disabled={showButton}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Item name={`${popup.language}-content`} initialValue={popup.content} rules={[{ required: false }]} hidden />
          <TextEditor
            init={{
              // @ts-expect-error convert to TS
              images_upload_handler: (blobInfo, success) => {
                prepareEditorContentImage({ file: blobInfo.blob(), location: "popups" }).then((res) => success(res));
              },
            }}
            initialValue={popup.content}
            onEditorChange={(content: string) => handleEditorChange(content, setContent)}
            value={content}
          />
        </Col>
      </Row>
    </>
  );
};
